import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const GrandSlam = ({ raceInfo, idGrandSlam, addToCart, entries }) => {
  let tablesGsl = [];
  // order races for race number
  entries.sort((a, b) => (a[0].RaceNumber < b[0].RaceNumber ? -1 : 0));

  entries &&
    entries.forEach((element, index) => {
      tablesGsl.push(
        <div key={index} style={{ borderTop: "1px solid #dee2e6" }}>
          <span
            style={{
              color: "#005580",
              fontFamily: "fantasy",
              fontSize: "20px",
            }}
          >
            R{element[0].RaceNumber}
          </span>
          <EntriesTable
            raceInfo={raceInfo}
            entriesInfo={element}
            wt={WagerTypes.GRANDSLAM.name}
            idWT={idGrandSlam}
            addToCart={addToCart}
            positionLeg={index}
          />
        </div>
      );
    });

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="GrandSlam"
        role="tabpanel"
        aria-labelledby="GrandSlam"
      >
        <div className="wrapper">{tablesGsl}</div>
      </div>
    </>
  );
};

export default GrandSlam;
